"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function PromotionsStatus(props) {
  var title = props.title,
    description = props.description,
    type = props.type;
  switch (type) {
    case 'wait':
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: 'promotions-status-container'
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/euuj391_time.png'
      }), /*#__PURE__*/_react["default"].createElement("strong", {
        className: 'promotions-status-container__strong'
      }, title, " "), /*#__PURE__*/_react["default"].createElement("p", {
        className: 'promotions-status-container__p'
      }, description, " "));
    case 'success':
      return /*#__PURE__*/_react["default"].createElement("section", {
        className: 'promotions-status-container'
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/QVbm292_free_trial.png'
      }), /*#__PURE__*/_react["default"].createElement("strong", {
        className: 'promotions-status-container__strong'
      }, title, " "), /*#__PURE__*/_react["default"].createElement("p", {
        className: 'promotions-status-container__p'
      }, description, " "));
  }
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: 'promotions-status-container'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: 'https://staticintl.cloudcachetci.com/cms/backend-cms/G4PD193_Group%20441%20%281%29.png'
  }), /*#__PURE__*/_react["default"].createElement("strong", {
    className: 'promotions-status-container__strong'
  }, title, " "), /*#__PURE__*/_react["default"].createElement("p", {
    className: 'promotions-status-container__p'
  }, description, " "));
}
var _default = exports["default"] = PromotionsStatus;